import ozNeighborhoodsGuideAds from './oz-neighborhoods-guide-ads.vue'

export default ozNeighborhoodsGuideAds
